// extracted by mini-css-extract-plugin
module.exports = {"dividerbottom":"FooterMiddle_dividerbottom__qOBjG","container":"FooterMiddle_container__GsQrp","big__list":"FooterMiddle_big__list__M9AFx"};